import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import emailjs from 'emailjs-com';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TOUR_TEMPLATE_ID || '';
const USER_ID = process.env.REACT_APP_EMAILJS_USER_ID || '';

const RondleidingForm: React.FC = () => {
  const { t } = useLanguage();
  const [form, setForm] = useState({ name: '', email: '', date: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, {
        name: form.name,
        email: form.email,
        date: form.date,
        message: form.message,
        form_type: 'Rondleiding',
      }, USER_ID);
      setSuccess(t('form.sendSuccess') || 'Message sent successfully!');
      setForm({ name: '', email: '', date: '', message: '' });
    } catch (err) {
      console.log(err);
      setError(t('form.sendError') || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">{t('form.rondleidingTitle')}</h2>
      <p className="mb-4">{t('form.rondleidingIntro')}</p>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder={t('form.fullName')}
          className="input-field"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder={t('form.emailAddress')}
          className="input-field"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="date"
          name="date"
          className="input-field"
          value={form.date}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder={t('form.message')}
          className="input-field"
          rows={3}
          value={form.message}
          onChange={handleChange}
        />
        <button
          type="submit"
          className="0 text-[#492A19] bg-[#FBEACD] border border-[#492A19] px-6 py-2 rounded-full font-bold hover:bg-[#492A19] hover:text-[#F9DCAC]"
          disabled={loading}
        >
          {loading ? t('form.sending') || 'Sending...' : t('form.send')}
        </button>
      </form>
      {success && <p className="text-green-600 mt-4">{success}</p>}
      {error && <p className="text-red-600 mt-4">{error}</p>}
    </div>
  );
};

export default RondleidingForm; 